import {
    MODA_PRODUCT_FORM_REQUEST,
    MODA_PRODUCT_FORM_SUCCESS,
    MODA_PRODUCT_FORM_ERROR,
    GET_ALL_MODA_PRODUCT_FORM_REQUEST,
    GET_ALL_MODA_PRODUCT_FORM_SUCCESS,
    GET_ALL_MODA_PRODUCT_FORM_ERROR,
    GET_ONE_MODA_PRODUCT_FORM_REQUEST,
    GET_ONE_MODA_PRODUCT_FORM_SUCCESS,
    GET_ONE_MODA_PRODUCT_FORM_ERROR,
    DELETE_MODA_PRODUCT_FORM_REQUEST,
    DELETE_MODA_PRODUCT_FORM_SUCCESS,
    DELETE_ONE_MODA_PRODUCT_FORM_ERROR,
    GET_ALL_MODA_PRODUCT_DETAIL_FORM_REQUEST,
    GET_ALL_MODA_PRODUCT_DETAIL_FORM_SUCCESS,
    GET_ALL_MODA_PRODUCT_DETAIL_FORM_ERROR,
} from "../actions/types"
export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
        case MODA_PRODUCT_FORM_REQUEST:
            return {
                loading: true,
            };
        case MODA_PRODUCT_FORM_SUCCESS:
            return {
                ...state,
                loading: false,
                payload: [payload],
            };
        case MODA_PRODUCT_FORM_ERROR:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_ALL_MODA_PRODUCT_FORM_REQUEST:
            return {
                loading: true,
            };
        case GET_ALL_MODA_PRODUCT_FORM_SUCCESS:
            return {
                ...state,
                loading: false,
                payload: payload,
            };
        case GET_ALL_MODA_PRODUCT_FORM_ERROR:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_ONE_MODA_PRODUCT_FORM_REQUEST:
            return {
                loading: true,
            };
        case GET_ONE_MODA_PRODUCT_FORM_SUCCESS:
            return {
                ...state,
                loading: false,
                payload: payload,
            };
        case GET_ONE_MODA_PRODUCT_FORM_ERROR:
            return {
                ...state,
                loading: false,
                payload,
            };
        case DELETE_MODA_PRODUCT_FORM_REQUEST:
            return {
                loading: true,
            };
        case DELETE_MODA_PRODUCT_FORM_SUCCESS:
            return {
                ...state,
                loading: false,
                payload: payload,
            };
        case DELETE_ONE_MODA_PRODUCT_FORM_ERROR:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_ALL_MODA_PRODUCT_DETAIL_FORM_REQUEST:
            return {
                loading: true,
            };
        case GET_ALL_MODA_PRODUCT_DETAIL_FORM_SUCCESS:
            return {
                ...state,
                loading: false,
                payload: payload,
            };
        case GET_ALL_MODA_PRODUCT_DETAIL_FORM_ERROR:
            return {
                ...state,
                loading: false,
                payload,
            };


        default:
            return state;
    }
}
